import { Component } from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import TargetPickerModal from '../../PageMetaMapping/present/TargetPickerModal'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'

class PageMatchReportPage extends Component {
    constructor(props) {
        super(props)
        this.state = { matchPk: null, matchTargetPk: null }
    }

    render() {
        const {
            candidates, cinemas, movieMappings, items,
            pyMovies, khMovies, compesoMovies, dieselMovies, cortecMovies, marsxMovies, vistaMovies,
            onMerge, goBackPath,
        } = this.props
        const { matchPk, matchTargetPk } = this.state
        const providerMoviesProps = { pyMovies, khMovies, compesoMovies, dieselMovies, cortecMovies, marsxMovies, vistaMovies }

        return (
            <WrapperPageSimple pageTitleTransId="match_report_page_title" overlay={<RequestOverlayContainer />} closePagePath={goBackPath}>
                <div className="match-report-page site-content">
                    {0 === candidates.length ? (
                        <div className="match-report-empty text-large-light">
                            <Translation id="match_report_empty_state" />
                        </div>
                    ) : (
                        <ul className="match-report-list">
                            {candidates.map(candidate => (
                                <li key={candidate.previewMovie.metaMoviePk} className="match-report-item">
                                    <div className="match-report-column">
                                        <div className="text-light-uppercase"><Translation id="preview_movies_section_film" /></div>
                                        <div className="text-large-light">{candidate.previewMovie.title}</div>
                                    </div>
                                    <div className="match-report-column">
                                        <div className="text-light-uppercase"><Translation id="match_report_fetched_movie_label" /></div>
                                        <div className="text-large-light">{candidate.fetchedMovie.title}</div>
                                    </div>
                                    <button
                                        className="tmdb-link-btn text-small-regular"
                                        onClick={() => this.setState({
                                            matchPk: candidate.previewMovie.metaMoviePk,
                                            matchTargetPk: candidate.fetchedMovie.metaMoviePk,
                                        })}
                                    >
                                        <Translation id="preview_movies_ks_connect_button" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {matchPk && (
                    <TargetPickerModal
                        type="merge"
                        movieMappings={movieMappings}
                        cinemas={cinemas}
                        providerMoviesProps={providerMoviesProps}
                        pmPreviewMovies={items}
                        excludePk={matchPk}
                        preselectedTargetPk={matchTargetPk}
                        onConfirm={(destinationPk, sourcePk) => {
                            onMerge(sourcePk !== undefined ? sourcePk : matchPk, destinationPk)
                            this.setState({ matchPk: null, matchTargetPk: null })
                        }}
                        onCancel={() => this.setState({ matchPk: null, matchTargetPk: null })}
                    />
                )}
            </WrapperPageSimple>
        )
    }
}

export default PageMatchReportPage
